var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className},[_c('div',{ref:"line",staticClass:"sheet"})])
}
var staticRenderFns = []

export { render, staticRenderFns }